import React, { useState, useEffect } from "react";
import { Box, Fab, Fade, useTheme } from "@mui/material";
import { KeyboardArrowUp as KeyboardArrowUpIcon } from "@mui/icons-material";

export const ScrollProgress: React.FC = () => {
  const [progress, setProgress] = useState(0);
  const [showBackToTop, setShowBackToTop] = useState(false);
  const theme = useTheme();

  useEffect(() => {
    const handleScroll = () => {
      // Calculate scroll progress
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;
      const scrollPercent = (scrollTop / (documentHeight - windowHeight)) * 100;

      setProgress(scrollPercent);
      setShowBackToTop(scrollTop > 800);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {/* Progress Bar */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: "2px",
          background:
            theme.palette.mode === "dark"
              ? "rgba(255, 255, 255, 0.05)"
              : "rgba(0, 0, 0, 0.05)",
          zIndex: 1300,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            height: "100%",
            width: `${progress}%`,
            background: "linear-gradient(90deg, #06B6D4, #0891B2)",
            boxShadow: "0 0 8px rgba(6, 182, 212, 0.3)",
            transition: "width 150ms ease-out",
          }}
        />
      </Box>

      {/* Back to Top Button */}
      <Fade in={showBackToTop}>
        <Fab
          size="small"
          aria-label="scroll back to top"
          onClick={handleBackToTop}
          sx={{
            position: "fixed",
            bottom: 24,
            right: 24,
            background: "linear-gradient(135deg, #06B6D4 0%, #0891B2 100%)",
            color: "white",
            width: 40,
            height: 40,
            minHeight: "auto",
            boxShadow: "0 4px 12px rgba(6, 182, 212, 0.25)",
            border: "2px solid rgba(255, 255, 255, 0.1)",
            backdropFilter: "blur(10px)",
            "&:hover": {
              background: "linear-gradient(135deg, #0891B2 0%, #06B6D4 100%)",
              transform: "translateY(-2px)",
              boxShadow: "0 8px 16px rgba(6, 182, 212, 0.35)",
            },
            "&:active": {
              transform: "translateY(0)",
              boxShadow: "0 4px 12px rgba(6, 182, 212, 0.25)",
            },
            transition: "all 200ms cubic-bezier(0.4, 0, 0.2, 1)",
            zIndex: 1200,
          }}
        >
          <KeyboardArrowUpIcon fontSize="small" />
        </Fab>
      </Fade>
    </>
  );
};
